import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'catgid', 'category', 'catgname', 'asetid', 'asdesc', 'asmodel',  'asuser', 'aslocat', 'inspectName'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/maintenasset${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                // delete data.materials;
                const resp = await axios.post('/maintenasset', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/maintenasset/${obj.maintAsstatKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await axios.get(`/maintenasset/detail/${obj.asetkey}`);
                resolve(result.data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'catgid', 'category', 'catgname', 'asetid', 'asdesc', 'asmodel', 'asuser', 'aslocat', 'inspectName'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/maintenasset/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'FixedAsset_maintenance_manual.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    category() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/fixedasset/category`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    asetstatus() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/maintenasset/asetstatus");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    }

};